import { render } from "./Function.vue?vue&type=template&id=1660d92f&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"

import "./Function.vue?vue&type=style&index=0&id=1660d92f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1660d92f"]])

export default __exports__